// extracted by css-extract-rspack-plugin
export default {"cls1":"ContentFeedback-cls1_Hbv","cls2":"ContentFeedback-cls2_bMH ContentFeedback-cls1_Hbv"};